import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const usePathParam = (param: string): number | undefined => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const target = new RegExp(`/${param}/[0-9]+`);
    const splitter = new RegExp(`/${param}/`);
    const result = pathname.match(target);
    if (result) {
      return Number(result[0].split(splitter)[1]);
    }
  }, [pathname, param]);
};
